module.exports = __webpack_public_path__ + "static/media/mail.383b6c41.webp";